// src/select/src/select-separator.tsx
import * as RadixSelectPrimitive from "@radix-ui/react-select";
import { jsx } from "react/jsx-runtime";
var SelectSeparator = () => {
  return /* @__PURE__ */ jsx(RadixSelectPrimitive.Separator, { className: "mx-1 my-2 h-px bg-surface-strong" });
};

export {
  SelectSeparator
};
